import React, { useEffect, useRef, useState } from 'react';

function DropDown(props: any) {
    const [show, setShow] = useState(false);
    const [inputVal, setInputVal] = useState('');
    const [error, setError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const inputRef = useRef<HTMLInputElement | null>(null);

    const validate = (data: any) => {
        try {
            //console.log({ data });
            if (data?.length == 0) {
                if (props?.inputProps?.[props.controlName]?.required) {
                    hideShowError(true);
                }

                props.setValue({ [props.controlName]: props?.inputProps?.[props.controlName]?.required ? null : '' });
            } else if (props?.inputProps?.[props.controlName]?.pattern) {
                const regmob = new RegExp(props?.inputProps?.[props.controlName]?.pattern);
                //console.log('regmob', regmob.test(data), props?.inputProps?.[props.controlName]?.pattern);
                if (!regmob.test(data)) {
                    setErrorMsg('Invalid Data'); //`${props?.data.name} is invalid. Please enter valid data`
                    props.setValue({
                        [props.controlName]: props?.inputProps?.[props.controlName]?.required ? null : '',
                    });
                    hideShowError(true);
                } else {
                    setErrorMsg('');
                    hideShowError(false);
                    props.setValue({ [props.controlName]: data });
                }
            } else {
                hideShowError(false);
                props.setValue({ [props.controlName]: data });
            }
            // props.setValue({ [props.controlName]: data })
            setInputVal(data);
        } catch (error) { }
    };

    // console.log('proips', props)

    useEffect(() => {
        try {
            if (!show) {
                setShow(props.isSubmit);
            }
            const d = props?.value?.toString() || inputVal ? props?.value?.toString() || inputVal.toString() : '';
            const data = { [props.controlName]: props?.inputProps?.[props.controlName]?.required ? (d ? d : null) : d };
            props.setValue(data);
            const inputValStr = inputVal ? inputVal.toString() : '';
            // //console.log('inputVal TextInput', d, inputValStr, inputValStr?.length, checkInputVali())
            if (inputValStr?.length > 0) {
                setError(checkInputVali());
            }
        } catch (error) {
            //console.log('error', error)
        }
    }, [props.isSubmit]);

    const checkInputVali = () => {
        if (props?.inputProps?.[props.controlName]?.pattern) {
            const regmob = new RegExp(props?.inputProps?.[props.controlName]?.pattern);
            if (!regmob.test(inputVal)) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    };

    useEffect(() => {
        setData();
    }, [props.inputProps]);

    useEffect(() => {
        setInputVal(props?.value || '');
        setData();
    }, [props.forceRender]);

    const setData = () => {
        try {
            const erMsg = props?.inputProps?.[props.controlName]?.message || null;
            setErrorMsg(erMsg);
            setError(props?.inputProps?.[props.controlName]?.error);
        } catch (error) { }
    };

    useEffect(() => {
        setInputVal(props?.value || '');
    }, [props.value]);

    const hideShowError = (flag: boolean) => {
        try {
            setShow(flag);
            setError(flag);
        } catch (error) { }
    };

    const dp = () => {
        const opdata = props?.options.filter(element => element !== undefined);
        return (
            <>
                {props.type == 'unit' && opdata?.length > 0 ? (
                    opdata
                        .filter((data: any) => data.name === props.itemtype)
                        .map((item: any, index: any) => {
                            return (
                                item.data.length > 0 &&
                                item.data.map((value: any, index: any) => {
                                    return (
                                        <option key={index} value={value}>
                                            {value}
                                        </option>
                                    );
                                })
                            );
                        })
                ) : opdata?.length > 0 ? (
                    opdata.map((item: any, index: any) => {
                        return (
                            <option value={item[props.optionValue]} key={item[props?.optionKey] || index}>
                                {item[props.displayName]}
                            </option>
                        );
                    })
                ) : (
                    <></>
                )}
            </>
        );
    };

    return (
        <React.Fragment>
            {/* <div>{(error) ? 'true' : 'false'} {(show) ? 'true' : 'false'}</div> */}
            {/* {props?.options?.length} */}
            <div className="form-floating">
                <select
                    className="form-select txt-cap-sel"
                    disabled={props.isDisabled ? true : false}
                    id={props.data?.id}
                    aria-label="Floating label select example"
                    value={inputVal}
                    onChange={e => {
                        validate(e.target.value);
                    }}
                >
                    <option value="">{props.data?.placeholder || 'Select'}</option>
                    {dp()}
                </select>
                {props.data?.id !== '' ? (
                    <label className="floatingSelect" htmlFor={props.data?.id}>
                        {props.data?.placeholder}
                        {props?.inputProps?.[props.controlName]?.required ? <sup className="text-red">*</sup> : ''}
                    </label>
                ) : (
                    ''
                )}

                {error && show && (
                    <div className="text-danger ft-12" style={{ marginLeft: '20px' }}>
                        {' '}
                        {errorMsg || 'Field is required'}
                    </div>
                )}
            </div>
        </React.Fragment>
    );
}

export default DropDown;
